import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import {
  ICancellationStatus,
  ICancellationStatusSearch,
  ICreateCancellationStatus,
  ICreateSecondaryCancellationStatus,
  ISecondaryCancellationStatus,
} from '../interfaces/cancellation-status';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CancellationStatusService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  entityTitle: string = 'CancellationStatus';

  getCancellationStatuses(search?: ICancellationStatusSearch): Promise<ICancellationStatus[]> {
    const url = '/api/cancellationStatuses';

    let myObject = {};

    if (search != null) {
      myObject = JSON.parse(JSON.stringify(search));
    }

    let params = new HttpParams({ fromObject: myObject });

    return this.handleRequest<any[]>(
      this.http.get<ICancellationStatus[]>(url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  getSecondaryCancellationStatuses(
    search?: ICancellationStatusSearch,
  ): Promise<ISecondaryCancellationStatus[]> {
    const url = '/api/secondaryCancellationStatuses';

    let myObject = {};

    if (search != null) {
      myObject = JSON.parse(JSON.stringify(search));
    }

    let params = new HttpParams({ fromObject: myObject });

    return this.handleRequest<any[]>(
      this.http.get<ISecondaryCancellationStatus[]>(url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  createCancellationStatus(dto: ICreateCancellationStatus) {
    const url = '/api/cancellationStatus';

    return this.handleRequest<any[]>(
      this.http.post<ICancellationStatus[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  patchCancellationStatus(id: number, patch: any) {
    const url = '/api/cancellationStatus/' + id;

    return this.handleRequest<any[]>(
      this.http.patch<ICancellationStatus[]>(url, patch),
      this.handlersFactory.getForReadAll(),
    );
  }

  createSecondaryCancellationStatus(dto: ICreateSecondaryCancellationStatus) {
    const url = '/api/secondaryCancellationStatus';

    return this.handleRequest<any[]>(
      this.http.post<ISecondaryCancellationStatus[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  patchSecondaryCancellationStatus(id: number, patch: any) {
    const url = '/api/secondaryCancellationStatus/' + id;

    return this.handleRequest<any[]>(
      this.http.patch<ISecondaryCancellationStatus[]>(url, patch),
      this.handlersFactory.getForReadAll(),
    );
  }
}
